export const EMPTY_ARRAY = [];
export const EMPTY_OBJECT = {};
export const EXPORT_ROW_LIMIT = '100000';
export const EMPTY_STRING = '';

export const sports = ['baseball', 'football', 'soccer', 'cricket', 'rugby'];
export const sportSelections = sports.map((s) => ({ name: s, displayKey: s }));

// copied from backend
export const OPTION_TYPES = {
    STRING: 'STRING',
    DATE: 'DATE',
    EMAIL: 'EMAIL',
    BOOL: 'BOOL',
    NUMBER: 'NUMBER',
    GROUP: 'GROUP',
    MULTISELECT: 'MULTISELECT',
    SELECT: 'SELECT',
    RADIO_GROUP: 'RADIO_GROUP',
    DOMAIN: 'DOMAIN',
    AUTH_CONTEXT: 'AUTH_CONTEXT',
    //AUTH_REQUIREMENTS: 'AUTH_REQUIREMENTS',
    // for things we want to provide but don't need to take input on
    META: 'META',
    LEAGUE_DATA: 'LEAGUE_DATA',
};

// copied from backend
// these are additional beyond required or not or base (i.e. date)
export const VALIDATION_TYPES = {
    EMAIL: 'EMAIL',
    FUTURE_DATE: 'FUTURE_DATE',
};
